/**
 * ResizeObserver can throw a benign loop warning when third-party widgets
 * (e.g. Elfsight) measure layout in the same frame. Defer callbacks and
 * filter dev-overlay noise so the homepage stays usable in local dev.
 */
const RESIZE_OBSERVER_LOOP_RE =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

function isResizeObserverLoopMessage(message) {
  if (message == null) {
    return false;
  }
  return RESIZE_OBSERVER_LOOP_RE.test(String(message));
}

function deferResizeObserverCallback(callback) {
  let frameId;

  return (entries, observer) => {
    if (frameId) {
      cancelAnimationFrame(frameId);
    }
    frameId = requestAnimationFrame(() => {
      frameId = undefined;
      callback(entries, observer);
    });
  };
}

if (typeof window !== 'undefined') {
  if (typeof window.ResizeObserver === 'function') {
    const NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
      constructor(callback) {
        super(deferResizeObserverCallback(callback));
      }
    };
  }

  window.addEventListener(
    'error',
    (event) => {
      if (!isResizeObserverLoopMessage(event.message)) {
        return;
      }
      event.stopImmediatePropagation();
      event.preventDefault();
    },
    true,
  );

  const originalConsoleError = console.error;
  console.error = (...args) => {
    const first = args[0];
    if (isResizeObserverLoopMessage(first)) {
      return;
    }
    if (first instanceof Error && isResizeObserverLoopMessage(first.message)) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}
